export default "__VITE_ASSET__c30a2d7c__"